import AxiosInstanceCreator from "services/api";

export const smartDeviceInstance = new AxiosInstanceCreator().create();
